function getArticleTagUTM() {
    const metaTag = document.querySelector('meta[name="article-tag"]');
    if (!metaTag) return '';
    let raw = metaTag.getAttribute('content') || '';
    return raw.toLowerCase()
              .trim()
              .replace(/&/g, 'and')
              .replace(/[^a-z0-9]+/g, '-')
              .replace(/^-+|-+$/g, '');
}

if (!sessionStorage.getItem('utm_session_started')) {
    localStorage.removeItem('first_visit_slug');
    localStorage.removeItem('first_utm_source');
    localStorage.removeItem('stored_utm_params');
    sessionStorage.setItem('utm_session_started', 'true');
}

function getCurrentSlug() {
    let path = window.location.pathname.replace(/\/$/, '');
    let slug = path.substring(path.lastIndexOf('/') + 1);
    return slug === '' ? 'home' : slug.replace('.html', '');
}

function getFirstVisitSlug() {
    let storedSlug = localStorage.getItem('first_visit_slug');
    if (!storedSlug) {
        storedSlug = getCurrentSlug();
        localStorage.setItem('first_visit_slug', storedSlug);
    }
    return storedSlug;
}

function isExternalReferrer() {
    const referrer = document.referrer;
    return referrer && !referrer.includes(location.hostname);
}

function getReferrerSource() {
    let source = localStorage.getItem('first_utm_source');
    if (!source && isExternalReferrer()) {
        try {
            const url = new URL(document.referrer);
            source = url.hostname.replace(/^www\./, '').replace(/\.[a-z]+$/, '');
            localStorage.setItem('first_utm_source', source);
        } catch (e) {
            source = '';
        }
    }
    return source || '';
}

function getStoredUTMParams() {
    const urlParams = new URLSearchParams(window.location.search);
    let storedUTM = JSON.parse(localStorage.getItem('stored_utm_params') || '{}');

    let finalSource = urlParams.get('utm_source');
    if (!finalSource) {
        finalSource = storedUTM.utm_source || getReferrerSource() || 'WOWMD';
    }

    const newUTM = {
        utm_source: finalSource,
        utm_medium: urlParams.get('utm_medium') || storedUTM.utm_medium || '',
        utm_campaign: urlParams.get('utm_campaign') || storedUTM.utm_campaign || ('WOWMD_' + getFirstVisitSlug()),
        utm_term: urlParams.get('utm_term') || storedUTM.utm_term || '',
        utm_content: urlParams.get('utm_content') || storedUTM.utm_content || ''
    };

    localStorage.setItem('stored_utm_params', JSON.stringify(newUTM));
    return newUTM;
}

function getCleanUTMString() {
    const utmObj = getStoredUTMParams();
    const cleaned = Object.fromEntries(Object.entries(utmObj).filter(([_, v]) => v));
    return new URLSearchParams(cleaned).toString();
}

function appendUTMParamsToLinks() {
    const utm = getCleanUTMString();
    document.querySelectorAll('a[href]').forEach(link => {
        let href = link.getAttribute('href');
        if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;

        const isInternal = link.hostname === location.hostname || !link.hostname;
        if (isInternal) {
            try {
                const linkURL = new URL(href, location.origin);
                const params = linkURL.searchParams;

                const allSources = params.getAll('utm_source');
                if (allSources.length > 1) {
                    params.delete('utm_source');
                    params.set('utm_source', allSources[0]);
                }

                if (!params.has('utm_campaign')) {
                    const utmParams = new URLSearchParams(utm);
                    for (const [key, value] of utmParams.entries()) {
                        if (!params.has(key)) {
                            params.set(key, value);
                        }
                    }
                }

                linkURL.search = params.toString();
                link.href = linkURL.toString();

            } catch (e) {
                const [base, query = ''] = href.split('?');
                const params = new URLSearchParams(query);

                const allSources = params.getAll('utm_source');
                if (allSources.length > 1) {
                    params.delete('utm_source');
                    params.set('utm_source', allSources[0]);
                }

                if (!params.has('utm_campaign')) {
                    const utmParams = new URLSearchParams(utm);
                    for (const [key, value] of utmParams.entries()) {
                        if (!params.has(key)) {
                            params.set(key, value);
                        }
                    }
                }

                const newQuery = params.toString();
                link.href = base + (newQuery ? '?' + newQuery : '');
            }
        }
    });
}

function updateCurrentPageURLWithUTM() {
    const url = new URL(window.location.href);
    const utmObj = getStoredUTMParams();
    let changed = false;
    for (const key in utmObj) {
        if (!url.searchParams.has(key) && utmObj[key]) {
            url.searchParams.set(key, utmObj[key]);
            changed = true;
        }
    }
    if (changed) {
        window.history.replaceState({}, '', url.toString());
    }
}

function updateCartAttributes() {
    const utm = getStoredUTMParams();
    fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: utm })
    })
    .then(res => res.json())
    .then(data => console.log('Cart updated with UTM:', data))
    .catch(err => console.error('Cart update error:', err));
}

function modifyCheckoutButtonURL() {
    const utmParams = getCleanUTMString();
    const checkoutButton = document.querySelector('button[name="checkout"], #checkout');
    if (checkoutButton) {
        checkoutButton.addEventListener('click', function(event) {
            event.preventDefault();
            const utm = getStoredUTMParams();
            fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes: utm })
            })
            .then(res => res.json())
            .then(data => {
                let checkoutURL = '/checkout';
                if (utmParams) {
                    checkoutURL += '?' + utmParams;
                }
                window.location.href = checkoutURL;
            })
            .catch(err => console.error('Error updating cart before checkout:', err));
        });
    }
}

function reapplyUTMOnVariantChange() {
    const utm = getCleanUTMString();
    const observer = new MutationObserver(() => {
        const url = new URL(window.location.href);
        const variant = url.searchParams.get('variant');

        if (variant) {
            const updatedUrl = new URL(window.location.origin + window.location.pathname);
            updatedUrl.searchParams.set('variant', variant);

            if (utm) {
                const utmParams = new URLSearchParams(utm);
                for (const [key, value] of utmParams.entries()) {
                    updatedUrl.searchParams.set(key, value);
                }
            }

            if (url.toString() !== updatedUrl.toString()) {
                window.history.replaceState({}, '', updatedUrl.toString());
            }
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

document.addEventListener('DOMContentLoaded', () => {
    reapplyUTMOnVariantChange();
    appendUTMParamsToLinks();
    updateCurrentPageURLWithUTM();

    if (window.location.pathname.includes('/cart')) {
        updateCartAttributes();
        modifyCheckoutButtonURL();
    } else if (window.location.pathname.includes('/checkouts')) {
        updateCurrentPageURLWithUTM();
    }
});

document.addEventListener('shopify:section:load', () => {
    appendUTMParamsToLinks();
    if (window.location.pathname.includes('/cart')) {
        updateCartAttributes();
        modifyCheckoutButtonURL();
    }
});